// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"dy","pgSpeechBox":"dy","speech-list-box":"dz","speechListBox":"dz"};